"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import posthog from "posthog-js";

export default function ChecklistInput() {
  const [url, setUrl] = useState("");
  const router = useRouter();

  const go = () => {
    const match = url.match(/[Ss](\d+)/);
    if (match) {
      posthog.capture("checklist_url_submitted", { checklist_id: `S${match[1]}` });
      router.push(`/checklist/S${match[1]}`);
    }
  };

  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
      <input
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && go()}
        placeholder="https://ebird.org/checklist/S177514369"
        className="waitlist-input"
        style={{ flex: 1, minWidth: 200 }}
      />
      <button
        onClick={go}
        className="waitlist-btn"
        disabled={!url.trim()}
        style={{ flexShrink: 0 }}
      >
        Preview →
      </button>
    </div>
  );
}
